import { IconButton, Snackbar } from '@material-ui/core';
import { Check, FileCopyOutlined, Share } from '@material-ui/icons';
import { Alert } from '@material-ui/lab';
import React, { useEffect, useState } from 'react';

type Props = {
  buttonSize?: 'medium' | 'small';
  iconSize?: number | string;
  color?: string;
};

function useSharingIsAvailable() {
  const [available, setAvailable] = useState(false);

  useEffect(() => {
    setAvailable(typeof navigator?.share === 'function');
  }, []);

  return available;
}

function useClipboardIsAvailable() {
  const [available, setAvailable] = useState(false);

  useEffect(() => {
    setAvailable(typeof navigator?.clipboard?.writeText === 'function');
  }, []);

  return available;
}

export default function ShareButton({ color = '#fff', buttonSize = 'medium', iconSize }: Props) {
  const [copied, setCopied] = useState(false);

  const sharingIsAvailable = useSharingIsAvailable();
  const clipboardIsAvailable = useClipboardIsAvailable();

  async function handleOnClick() {
    try {
      if (sharingIsAvailable) await share();
      else await copyToClipboard();
    } catch (error) {}

    async function share() {
      await navigator.share({
        url: window.location.href,
      });
    }

    async function copyToClipboard() {
      await navigator?.clipboard?.writeText(window.location.href);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  }

  const iconStyle = { color, ...(iconSize ? { fontSize: iconSize } : {}) };
  const shareIcon = sharingIsAvailable ? <Share style={iconStyle} /> : <FileCopyOutlined style={iconStyle} />;

  if (!sharingIsAvailable && !clipboardIsAvailable) return null;

  return (
    <>
      <IconButton onClick={handleOnClick} size={buttonSize}>
        {copied ? <Check style={iconStyle} /> : shareIcon}
      </IconButton>
      <Snackbar open={copied} anchorOrigin={{ horizontal: 'center', vertical: 'top' }}>
        <Alert severity="info">Link copiado para área de tranferência</Alert>
      </Snackbar>
    </>
  );
}
